import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-pill px-2.5 py-0.5 text-xs font-semibold transition-colors',
  {
    variants: {
      variant: {
        default:     'bg-primary-100 text-primary-700',
        secondary:   'bg-cream-3 text-muted border border-rule',
        destructive: 'bg-error/10 text-error border border-error/20',
        success:     'bg-success/10 text-success border border-success/20',
        warning:     'bg-accent-100 text-accent-700',
        accent:      'bg-accent-100 text-accent-700',
        rx:          'bg-rx-flag/10 text-rx-flag border border-rx-flag/30 uppercase tracking-widest text-[10px] font-bold',
        schedule:    'bg-accent-50 text-accent-700 border border-accent-200/60 uppercase tracking-widest text-[10px] font-bold',
      },
    },
    defaultVariants: { variant: 'default' },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

const Badge = ({ className, variant, ...props }: BadgeProps) => (
  <div className={cn(badgeVariants({ variant }), className)} {...props} />
);

export { Badge, badgeVariants };
